module.exports = __webpack_public_path__ + "static/media/tfn.ae6f37f5.jpg";